<label>{{ "CardModal.DeliveryMethod" | translate }}</label>
<kendo-dropdownlist-wrapper
    name="deliveryMethod"
    [data]="cardModalService.deliveryMethods()"
    formControlName="deliveryMethod"
    [textField]="cardModalService.isiFirmDeliveryMethods() ? helpersService.getLang() : 'value'"
    [valueField]="cardModalService.isiFirmDeliveryMethods() ? 'Id' : 'key'"
/>
